const landingPagesReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PAGES':
      return action.data
    default:
      return state
  }
}

export default landingPagesReducer
